<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-body">
                <form (ngSubmit)="isEditing?editScale():createScale()">
                    <div class="form-body">
                        <h3 class="card-title">Crear/editar escalas Mips</h3>
                        <hr>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Titulo</label>
                                    <input [(ngModel)]="title" [ngModelOptions]="{standalone:true}" type="text"  class="form-control" placeholder="Título">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label" for="">Grupo</label>
                                    <select [(ngModel)]="group" [ngModelOptions]="{standalone:true}" class="form-control" name="" id="">
                                        <option disabled value="">Seleccione un grupo...</option>
                                        <option value="Metas Motivacionales">Metas Motivacionales</option>
                                        <option value="Modos Cognitivos">Modos Cognitivos</option>
                                        <option value="Conductas Interpersonales">Conductas Interpersonales</option>
                                        <option value="Escalas de validez">Escalas de validez</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-rounded waves-effect btn-primary pull-right" type="submit">{{isEditing?'Actualizar':'Crear'}}</button>
                    </div>
                </form>
                <div class="table-responsive m-t-20">
                    <h4 class="card-title">Escalas</h4>
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Titulo</th>
                                    <th>Grupo</th>
                                    <th class="text-nowrap">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let scale of scales; index as i">
                                    <td>{{scale.scale}}</td>
                                    <td>{{scale.group}}</td>
                                    <td class="text-center">
                                        <a href="javascript:void(0)" (click)="deleteScale(i, scale._id)" data-toggle="tooltip" data-original-title="Borrar"> <i class="fa fa-close text-danger m-r-20"></i> </a>
                                        <a href="javascript:void(0)" (click)="handleEdit(scale, i)"> <i class="fa text-dark fa-pencil"></i> </a>
                                    </td>
                                </tr>
                             </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
